"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import AlertArea from "../../components/alert_area";
import { FlashMessages } from "../../components/flash_messages";
function ResetPasswordLayout(props) {
  return /* @__PURE__ */ jsxs("div", { "data-component": "ResetPasswordLayout", className: "react-wrapper", children: [
    /* @__PURE__ */ jsx("div", { className: "contain-to-grid", children: /* @__PURE__ */ jsxs("nav", { className: "top-bar main-nav", "data-topbar": true, role: "navigation", children: [
      /* @__PURE__ */ jsx("ul", { className: "title-area", children: /* @__PURE__ */ jsx("li", { className: "name", children: /* @__PURE__ */ jsx("h1", { children: /* @__PURE__ */ jsx("a", { href: "/app", children: /* @__PURE__ */ jsx(
        "img",
        {
          src: "/assets/TriumphLogoWhite.svg",
          className: "hubtran-logo"
        }
      ) }) }) }) }),
      /* @__PURE__ */ jsx("section", { className: "top-bar-section" })
    ] }) }),
    /* @__PURE__ */ jsx(AlertArea, {}),
    /* @__PURE__ */ jsxs("div", { id: "container", children: [
      /* @__PURE__ */ jsx("div", { id: "flash-messages", children: /* @__PURE__ */ jsx(FlashMessages, {}) }),
      /* @__PURE__ */ jsx("div", { id: "mainViewContainer", children: /* @__PURE__ */ jsx("div", { className: "row", children: props.children }) })
    ] })
  ] });
}
export default ResetPasswordLayout;
